import { render } from "./PhoneGroup.vue?vue&type=template&id=7fae83e9&scoped=true"
import script from "./PhoneGroup.vue?vue&type=script&lang=js"
export * from "./PhoneGroup.vue?vue&type=script&lang=js"

import "./PhoneGroup.vue?vue&type=style&index=0&id=7fae83e9&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fae83e9"]])

export default __exports__